import { render, staticRenderFns } from "./ChapterSetUp.vue?vue&type=template&id=23f8092c&"
import script from "./ChapterSetUp.vue?vue&type=script&lang=js&"
export * from "./ChapterSetUp.vue?vue&type=script&lang=js&"
import style0 from "./ChapterSetUp.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"
import style1 from "./ChapterSetUp.vue?vue&type=style&index=1&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports